// extracted by mini-css-extract-plugin
export default {"chip":"chip_chip__4GjlP"};